import { ASSET_QUALITY } from '@shootsta/common-domain-data';

const { ORIGINAL, HD, SD } = ASSET_QUALITY;

// The quality tier leads each line: "High Resolution" reads like the best
// option to most people, when Original is in fact the highest quality file.
export const DETAILS_MAP_ENABLED = {
  [ORIGINAL]: 'Highest quality — the original uploaded video file',
  [HD]: 'Medium quality — perfect for most presentations or web uses',
  [SD]: 'Lowest quality — suited for slower connections or previews'
};
